import request from '@/api/config/request'

const prex_pix = "api/admin/gestao/retorno_pagamento/pix";
const prex_boleto = "api/admin/gestao/retorno_pagamento/boleto";

export function listRetornoPagamentoPix(query = {}) {
    return request({
        url: `${prex_pix}`,
        method: 'get',
        params: query
    })
}

export function verificaRetornoPagamentoPix(pix_hash) {
    return request({
        url: `${prex_pix}/${pix_hash}`,
        method: 'get'
    })
}

export function listRetornoPagamentoBoleto(query = {}) {
    return request({
        url: `${prex_boleto}`,
        method: 'get',
        params: query
    })
}

export function verificaRetornoPagamentoBoleto(bol_hash) {
    return request({
        url: `${prex_boleto}/${bol_hash}`,
        method: 'get'
    })
}